import React from 'react';
import logComponent from '../../common/logComponent';
import './CorporationCard.css';

export default function CorporationCard({ corporation }) {
  if (logComponent('CorporationCard')) { console.debug('CorporationCard rendered'); }

  return (
    <div className="Corporation-Card">
      <p className="Corporation-Card__name">{ corporation.name }</p>
    </div>
  )
}
